export enum OverlayActions {
  CREATE = "create_overlay",
  UPDATE = "update_overlay",
  GET = "get_overlay",
  GET_ALL = "get_overlays",
  DELETE = "delete_overlay"
}